module.exports = __webpack_public_path__ + "static/media/1-5.cb30e78d.png";